export function normalizeWorklogSearchValue(value) {
  return `${value || ""}`.toLowerCase().replace(/\s+/g, " ").trim();
}

export function matchesWorklogSearch(worklog, searchText) {
  const normalizedSearchText = normalizeWorklogSearchValue(searchText);

  if (!normalizedSearchText) {
    return true;
  }

  const boardKey = normalizeWorklogSearchValue(worklog?.key);
  const cardId = normalizeWorklogSearchValue(worklog?.cardlog?.card?.card_id);
  const boardCardKey = normalizeWorklogSearchValue(
    `${worklog?.key || ""}-${worklog?.cardlog?.card?.card_id || ""}`
  );
  const title = normalizeWorklogSearchValue(worklog?.cardlog?.card?.title);
  const epicName = normalizeWorklogSearchValue(worklog?.epic_name);
  const workflowStepName = normalizeWorklogSearchValue(worklog?.workflow_step_name);
  const userFirstName = normalizeWorklogSearchValue(
    worklog?.cardlog?.user?.first_name
  );
  const userLastName = normalizeWorklogSearchValue(
    worklog?.cardlog?.user?.last_name
  );
  const workPerformed = normalizeWorklogSearchValue(
    worklog?.cardlog?.work_performed
  );

  return (
    title.includes(normalizedSearchText) ||
    cardId.includes(normalizedSearchText) ||
    boardKey.includes(normalizedSearchText) ||
    boardCardKey.includes(normalizedSearchText) ||
    epicName.includes(normalizedSearchText) ||
    workflowStepName.includes(normalizedSearchText) ||
    userFirstName.includes(normalizedSearchText) ||
    userLastName.includes(normalizedSearchText) ||
    workPerformed.includes(normalizedSearchText)
  );
}
